import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "performInfos",
  style: {"height":"300px"}
}

import { onMounted, reactive, nextTick } from 'vue';
import * as echarts from 'echarts';
type EChartsOption = echarts.EChartsOption;

import { PerformAmtInfoApi } from '@/apis/homes/apis';
import moment from 'moment';



export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = reactive({
    loading: false,
    hasError: false,
})

const genCharts = async () => {
    // state.loading = true

    const { succeeded, data } = await PerformAmtInfoApi()

    state.hasError = !succeeded;

    if (succeeded) {
        const chartDom = document.getElementById('performInfos')!;
        const myChart = echarts.init(chartDom, null, {
            renderer: 'svg'
        });

        var datas =  [
            { value: data.unPayAmt, name: '未申请金额' },
            { value: data.auditPayAmt, name: '审批中金额' },
            { value: data.waitToPayAmt, name: '待支付金额' },
            { value: data.isPayAmt, name: '已支付金额' },
        ];

        const option: EChartsOption = {
            title: {
                text: '合同履约情况统计',
                subtext: moment().format('YYYY年MM月DD日'),
                left: 'center'
            },
            tooltip: {
                trigger: 'item'
            },
            legend: {
                orient: 'vertical',
                left: 'left'
            },
            series: [
                {
                    name: 'Datas',
                    type: 'pie',
                    radius: '50%',
                    data: datas,
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };

        // if (res.su)
        option && myChart.setOption(option);
    }
}

onMounted(async () => {
    await genCharts()
})

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!

  return (!_unref(state).hasError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
    : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        "image-size": 60,
        description: "数据读取异常"
      }))
}
}

})